// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBy011LJN_0sCe6EZPK6di7rhS4Y3f9mPY",
  authDomain: "gasenieurra-c6b7c.firebaseapp.com",
  projectId: "gasenieurra-c6b7c",
  storageBucket: "gasenieurra-c6b7c.firebasestorage.app",
  messagingSenderId: "63131144284",
  appId: "1:63131144284:web:0e96b043c30e7ef9ad5699",
  measurementId: "G-RMPE25L7D0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, analytics, auth, db, storage };
